// extracted by mini-css-extract-plugin
module.exports = {"iframeContainer":"ExhibitionDetailsPage_iframeContainer__WWQ9t"};